import { io } from "socket.io-client";
import { socket } from "@/network/socket";
import { State } from "./state";
import toast from "@/plugins/toast";
import i18n from "@/i18n";
import router from "../router/index";
import audioFile from "@/assets/ringtone.mp3";
import audioFile2 from "@/assets/ringtone2.mp3";
import audioFile3 from "@/assets/ringtone3.mp3";

const audio = new Audio(audioFile);
const audio2 = new Audio(audioFile2);
const audio3 = new Audio(audioFile3);

//intialize and connect
export default class chatStore {
  admin_id = localStorage.getItem("admin_id");
  socketData = {
    socket: null,
    rooms: [],
    roomsPage: 1,
    currentRoom: {
      user: null,
      id: null,
      data: [],
    },
    roomsData: {},
    roomTempData: [],
    usersNames: {},
    chatToken: localStorage.getItem("chat_token"),
    active: -1,
  };
  chatState = new State();
  getAllRoomsSate = new State();
  getRoomMessagesState = new State();
  getRoomMessagesPaginationState = new State();
  addRoomByIdState = new State();
  sendMessageState = new State();
  readMessageState = new State();
  getRoomPaginationState = new State();

  socketConnection({ domanin, transports, autoConnect, authorization }) {
    return new Promise((res, rej) => {
      this.socketData.socket = io(domanin, {
        transports: transports,
        autoConnect: autoConnect,
        extraHeaders: {
          authorization: authorization,
        },
      });

      this.socketData.socket.on("connect", () => {
        console.log("connect");
        return res(true);
      });
      this.socketData.socket.on("connect_error", () => {
        console.log("not connect");
        return rej(false);
      });
    });
  }

  async checkConnectStatus() {
    if (this.socketData.chatToken) {
      await this.socketConnection({
        domanin: "https://pages-chat-dev.octa-apps.com",
        transports: ["polling"],
        autoConnect: true,
        authorization: this.socketData.chatToken,
      });
    }
  }

  // get all rooms in my chat

  async getRoomPagination(payload) {
    let messages = new socket({
      socket: this.socketData.socket,
      type: "room:get",
      payload: payload,
    });
    await this.getRoomPaginationState.trigger(
      async () => {
        return await messages.send();
      },
      {
        onSuccess: (value) => {
          this.socketData.roomsPage += 1;
          if (value.data.length == 0) this.socketData.roomsPage = -1;
          this.socketData.rooms = this.socketData.rooms.concat(value.data);
          this.setRoomsUsers(value.data);
          console.log(this.socketData.usersNames);
        },
        onError: () => {},
      }
    );
  }
  async addRoomById(id) {
    let messages = new socket({
      socket: this.socketData.socket,
      type: "room:get-by-id",
      payload: {
        room: {
          id: id,
        },
      },
    });
    await this.addRoomByIdState.trigger(
      async () => {
        return await messages.send();
      },
      {
        onSuccess: (value) => {
          this.socketData.rooms.unshift(value.data);
          value.data.Users.forEach((user) => {
            Object.assign(this.socketData.usersNames, {
              [user.id]: user.type,
            });
          });
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }

  async getRoomMessages(data) {
    if (this.checkRoomIsCash(data)) return;
    this.socketData.currentRoom.id = data.id;
    this.socketData.currentRoom.user = data;

    let messages = new socket({
      socket: this.socketData.socket,
      type: "message:get",
      payload: {
        room: {
          id: data.id,
        },
      },
    });
    await this.getRoomMessagesState.trigger(
      async () => {
        return await messages.send();
      },
      {
        onSuccess: (value) => {
          Object.assign(this.socketData.roomsData, {
            [data.id]: { id: data.id, data: value.data },
          });
          this.socketData.currentRoom.data = value.data;
        },
        onError: () => {},
      }
    );
  }
  async getRoomMessagesPagination(id, page) {
    let messages = new socket({
      socket: this.socketData.socket,
      type: "message:get",
      payload: {
        room: {
          id: id,
        },
        pagination: {
          page: page,
        },
      },
    });
    await this.getRoomMessagesPaginationState.trigger(
      async () => {
        return await messages.send();
      },
      {
        onSuccess: (value) => {
          this.socketData.roomsData[id].data = this.socketData.roomsData[
            id
          ].data.concat(value.data);
          this.socketData.currentRoom.data = this.socketData.roomsData[id].data;
        },
        onError: () => {},
      }
    );
  }
  setRoomsUsers(data) {
    data.forEach((item) => {
      item.Users.forEach((user) => {
        Object.assign(this.socketData.usersNames, {
          [user.id]: user.type,
        });
      });
    });
    Object.assign(this.socketData.usersNames, {
      [this.admin_id]: "admin",
    });
  }

  checkRoomIsCash(data) {
    if (data.id in this.socketData.roomsData) {
      this.socketData.currentRoom.data =
        this.socketData.roomsData[data.id].data;
      this.socketData.currentRoom.id = this.socketData.roomsData[data.id].id;
      this.socketData.currentRoom.user = data;
      return true;
    }
    return false;
  }

  // send messages
  async sendMessage(payload) {
    //create state for every message
    let state = new State();

    //check if message is replied to another message
    if (payload.message.repliedMessage != null) {
      payload.message.repliedMessage = payload.message.repliedMessage.id;
    }

    //
    if (payload.message.type == "text") {
      this.socketData.roomTempData.unshift({ ...payload.message });
    }
    //intialize
    let messages = new socket({
      socket: this.socketData.socket,
      type: "message:create",
      payload: payload,
    });
    state.trigger(
      async () => {
        return await messages.send();
      },
      {
        onSuccess: (value) => {
          audio.play();
          this.operationsInMessage(value);
          this.socketData.roomsData[payload.room.id].data.unshift({
            ...value.data,
          });

          //for set room with last message in top
          this.moveMessage(payload, value.data);
        },
        onError: () => {
          this.socketData.roomTempData.pop();
        },
      }
    );
  }
  readMessage(id) {
    let messages = new socket({
      socket: this.socketData.socket,
      type: "message:read",
      payload: {
        message: {
          id: id,
        },
      },
    });
    this.readMessageState.trigger(
      async () => {
        return await messages.send();
      },
      {
        onError: (value) => {
          console.log(value);
        },
      }
    );
  }
  operationsInMessage(value) {
    Object.assign(value.data, { ["userId"]: value.data.user.id });
    let file = this.socketData.roomTempData.filter(
      (item) => item.content == value.data.content
    );
    Object.assign(value.data, { file: file[0].file });
    let i = this.socketData.roomTempData.indexOf(file[0]);
    this.socketData.roomTempData.splice(i, 1);
  }
  // messages events
  async getNewMessages() {
    this.socketData.socket.on("message:income", async (msg) => {
      this.getToast(msg);

      Object.assign(msg, { userId: msg.user.id });
      if (this.socketData.rooms.length == 0) return;
      this.addNewMessage(msg);
      //  let filter =this.socketData.rooms
    });
  }

  addNewMessage(msg) {
    if (msg.room.id in this.socketData.roomsData) {
      if (this.socketData.currentRoom.id == msg.room.id) {
        audio2.play();
        msg.readBy.ids = msg.readBy.ids.concat(this.admin_id);
        this.readMessage(msg.id);
      }
      this.socketData.roomsData[msg.room.id].data.unshift(msg);
    }
    if (this.socketData.rooms.length > 0) {
      let filter = this.socketData.rooms.filter(
        (item) => item.id == msg.room.id
      );
      if (filter.length > 0) {
        let index = this.socketData.rooms.indexOf(filter[0]);
        this.socketData.rooms[index].Messages[0] = msg;
        let item = this.socketData.rooms[index];
        this.socketData.rooms.splice(index, 1);
        this.socketData.rooms.unshift(item);
        return;
      }
      this.addRoomById(msg.room.id);
    }
  }
  async getReadMessages() {
    this.socketData.socket.on("message:read", (msg) => {
      if (this.socketData.rooms.length > 0) {
        let room = this.socketData.rooms.filter(
          (item) => item.id == msg.room.id
        );
        let index = this.socketData.rooms.indexOf(room[0]);
        if (this.socketData.rooms[index].Messages[0].id == msg.message.id) {
          Object.assign(this.socketData.rooms[index].Messages[0].readBy, {
            ["admin"]: true,
          });
          let message = this.socketData.rooms[index].Messages[0];
          this.socketData.rooms[index].Messages.pop();
          this.socketData.rooms[index].Messages.push(message);
        }
      }
    });
  }

  moveMessage(payload, data) {
    let room = this.socketData.rooms.filter(
      (item) => item.id == payload.room.id
    );
    let index = this.socketData.rooms.indexOf(room[0]);
    this.socketData.rooms.splice(index, 1);
    this.socketData.rooms.unshift(room[0]);
    this.socketData.rooms[0].Messages[0] = data;
  }
  getToast(msg) {
    if (router.currentRoute.name != "support") {
      toast(
        i18n.t("message from") + " " + msg.user.name,
        { timeout: 4000, rtl: true },
        "info"
      );
      try {
        audio3.play();
      } catch (error) {
        console.log(error);
      }
    }
  }
}

export const Chat = new chatStore();
